import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  promoCode: {
    display: 'flex',
    gap: '.5rem',
    border: `1px solid ${theme.palette.secondary.main}`,
    padding: '.3rem',
    paddingLeft: '1rem',
    paddingRight: '1rem',
    borderRadius: '0.2rem',
    alignItems: 'center',
  },
  policyNumber: {
    fontSize: '0.9rem',
    fontWeight: 'bolder',
  },
  iconButton: {
    padding: 0,
  },
}));

export default useStyles;
